export default __webpack_public_path__ + "static/media/tab2_3.1a44603f.png";